import { ArrowRightIcon, Button, Flex, Heading } from '@buffer-mono/popcorn'

import { AnimatedBackground } from './AnimatedBackground'

import styles from './IntroductionStep.module.css'

import type { JSX } from 'react'

interface IntroductionStepProps {
  title: string
  buttonText: string
  firstName?: string | null
  loading?: boolean
  onStart: () => void
}

/**
 * @hardcoded The greeting "Hey there [name] 👋🏾" (including emoji and skin tone) is
 *   hardcoded. Only `title` below it comes from the API.
 * @fix Add `greetingPrefix` or `greetingTemplate` to `IntroductionStep` in the
 *   GraphQL schema, or include the full greeting in `title`.
 */
export function IntroductionStep({
  title,
  buttonText,
  firstName,
  loading,
  onStart,
}: IntroductionStepProps): JSX.Element {
  return (
    <div className={styles.wrapper}>
      <AnimatedBackground />
      <Flex
        className={styles.content}
        direction="column"
        gap="lg"
        align="center"
      >
        <Flex direction="column" gap="xs" align="center">
          <Heading as="h1" size="xl" align="center">
            Hey there
            {firstName ? (
              <span translate="no">{` ${firstName}`}</span>
            ) : null}{' '}
            👋🏾
            <br />
            <span translate="no">{title}</span>
          </Heading>
        </Flex>
        <Button size="large" onClick={onStart} loading={loading}>
          {buttonText} <ArrowRightIcon />
        </Button>
      </Flex>
    </div>
  )
}
